<template>
  <form-code
    ref="formCode"
    :classes="'step'"
    :isDisabled="false"
    :netError="netError"
    @valid="requestLoginWithCode">
    <p slot="header">{{L10n('enter-code')}}</p>
    <template slot="footer">
      <div class="buttons">
        <button
          type="button"
          class="btn btn-back"
          @click="$emit('step', 'email')">
          <i class="fas fa-chevron-left"/>
          {{L10n('back')}}
        </button>
        <el-button
          type="button"
          class="btn"
          ref="submit"
          @click="submitForm()">
          {{L10n('submit')}}
        </el-button>
      </div>
    </template>
  </form-code>
</template>

<script>
export default {
  name: 'StepCode',
  props: { email: { type: String, required: true } },
  components: { 'form-code': () => import(/* webpackChunkName: 'Form' */ '@/components/Form/FormCode') },
  data () {
    return {
      netError: ''
    }
  },
  mounted () {
    setTimeout(_ => {
      this.$refs.formCode.setFocus()
    }, 700)
  },
  methods: {
    submitForm () {
      this.$refs.formCode.submitForm()
    },
    requestLoginWithCode (Code) {
      let loading = this.$loading({ lock: true })
      const payload = {
        languageID: 1,
        rememberMe: true,
        email: this.email,
        code: Code
      }
      this.netError = ''

      this.$store.dispatch('accountLogin', payload)
        .then(_ => {
          loading.close()
          this.$router.replace({ name: 'Dashboard' })
        })
        .catch(error => {
          loading.close()
          // this.requestErrorHandler(error, this.L10n('general-error'))
          this.netError = this.globalMixinErrorResponse(error, this.L10n('general-error'))
        })
    }
  }
}
</script>
